import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/modules/common/components/Footer.tsx");
